var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[_c('detail-header'),_vm._v(" "),_c('detail-banner',{attrs:{"gallaryImgs":_vm.gallaryImgs,"sightName":_vm.sightName,"bannerImg":_vm.bannerImg}}),_vm._v(" "),_c('detail-list',{attrs:{"detail-list":_vm.detailList}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b39b9a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/detail/detail.vue
// module id = null
// module chunks = 